import {Text} from "react-native";

export const backText = <Text>
    되돌아가시겠어요?{'\n'}돌아가는 길에도{'\n'}
    QR코드를 찍어야{`\n`}봉사시간에 반영됩니다.
</Text>